import { isUndefined } from '../predicates/type';
import { bodyOverlayPositionActiveClass } from './renderProps/OverlayPosition/overlayPositionDefaults';

function scrollTo({
	x = 0,
	y = 0,
	behavior = 'instant',
}: {
	x?: number;
	y?: number;
	behavior?: 'auto' | 'instant' | 'smooth';
}) {
	window.__restore_window_scroll = false;

	if (document.body.classList.contains(bodyOverlayPositionActiveClass)) {
		if (!isUndefined(y)) {
			document.documentElement.style.top = `${y}px`;
		}

		if (!isUndefined(x)) {
			document.documentElement.style.left = `${x}px`;
		}

		return;
	}

	window.scroll({
		left: x,
		top: y,
		// @ts-ignore
		behavior,
	});
}

export { scrollTo };
